import { Repository } from "../../adapters/repository";
import { present } from "../../../utils/presenter";
import { Interactor } from "./types";

function createInteractor(repository: Repository): Interactor {
  return ({ document, folder, type, namespace }) =>
    present(
      repository
        .copyDocument(document, folder, type, namespace)
        .then(() => ({ document, folder, type, namespace }))
        .catch(() => Promise.reject({ document, folder, type, namespace })),
    );
}

export type { Interactor };

export { createInteractor };
